import React from 'react';
import styled from '@emotion/styled';
import {
  BREAKPOINT_PHONE,
  BREAKPOINT_TABLET,
  BREAKPOINT_PC,
  MediaQueries,
} from './MediaQuery';

const DefaultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh; // 무한스크롤 대비
  align-items: center;

  ${MediaQueries(BREAKPOINT_PC)} {
    padding: 0 26px;
  }

  ${MediaQueries(BREAKPOINT_TABLET)} {
    padding: 0 26px;
  }

  ${MediaQueries(BREAKPOINT_PHONE)} {
    padding: 0 26px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const DefaultTemplate = ({ style, children }) => {
  return (
    <DefaultWrapper style={{ ...style }}>
      <Container>{children}</Container>
    </DefaultWrapper>
  );
};

export default DefaultTemplate;
